function calculateElementContentHeight(container) {
  const contentHeight = Array.prototype.reduce.call(container.children, function (height, child) {
    const style = getComputedStyle(child);
    const total = height + child.offsetHeight + parseInt(style.marginTop) + parseInt(style.marginBottom);
    return total;
  }, 0);
  return contentHeight;
}

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');
    window.removeEventListener('keydown', handleFirstTab);
  }
}

function isMobile() {
  return (window.innerWidth < 680);
}

/**
 * Modify a number for display by separating every third order of magnitude
 * with an indicator.
 *
 * @param number - The float or integer to be displayed.
 * @param indicator - The character with which to indicate every new segment.
 *
 * @returns A string representing the number formatted with an indicator to
 * separate thousands, millions, etc.
 */
function formatLargeNumber(number, indicator) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, indicator);
}

/**
 * Find the closest parent that has a given class.
 *
 * @param element - The element whose parent we want to find.
 * @param className - The class name a matching parent should have.
 *
 * @returns The closest element in the parent tree that has the given class or,
 * if none can be found, null.
 */
function findParent(element, className) {
  const parent = element.parentNode;

  // If parent has the target class, return it.
  if (parent && parent.classList && parent.classList.contains(className)) {
    return parent;
    // Otherwise, if parent exists, re-invoke this function with it.
  } else if (parent) {
    return findParent(parent, className);
  }

  // If we’ve reched the top of the tree and there is no parent, return null.
  return null;
}

window.addEventListener('keydown', handleFirstTab);

// Array.from() polyfill.
// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
  Array.from = (function () {
    const toStr = Object.prototype.toString;
    const isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    const toInteger = function (value) {
      const number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    const maxSafeInteger = Math.pow(2, 53) - 1;
    const toLength = function (value) {
      const len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      const C = this;

      // 2. Let items be ToObject(arrayLike).
      const items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }

      // 4. If mapfn is undefined, then let mapping be false.
      const mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      let T = null;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      const len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      const A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      let k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      let kValue = null;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}

// Object.assign() polyfill.
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      const to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        const nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (const nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

// NodeList.forEach() polyfill.
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// Creates a global event emitter for emitting and listening for custom events.
// This is helpful for communication between component JS and applications
// implementing them.
//
// To listen for an event (within a component, for example):
//
// ```
// (function (window) {
//   'use strict';
//
//   function init() {
//     // Called on page load and when the event is triggered.
//   }
//
//   // Allow application JS to reinitialize any instances added with Ajax, etc.
//   if (typeof componentEvents !== 'undefined') {
//     componentEvents.on('component-init', init);
//   }
//
//   init();
//
// })(this);
// ```
//
// To emit an event (within application JS, for example):
//
// ```
// window.componentEvents.emitEvent('component-init');
// ```
window.componentEvents = new EvEmitter();

(function () {

  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: {} };
    const evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

function isHidden(el) {
  return (getComputedStyle(el, null).display === 'none');
}

// Handle keydown events within an active modal.
function handleModalKeydown(e, modalCloseFunc) {
  const interactiveElements = [
    'a[href]:not([tabindex^="-"]):not([inert])',
    'area[href]:not([tabindex^="-"]):not([inert])',
    'input:not([disabled]):not([inert])',
    'select:not([disabled]):not([inert])',
    'textarea:not([disabled]):not([inert])',
    'button:not([disabled]):not([inert])',
    'iframe:not([tabindex^="-"]):not([inert])',
    'audio:not([tabindex^="-"]):not([inert])',
    'video:not([tabindex^="-"]):not([inert])',
    '[contenteditable]:not([tabindex^="-"]):not([inert])',
    '[tabindex]:not([tabindex^="-"]):not([inert])'
  ];
  const tabKey = 9;
  const escKey = 27;
  const modal = e.currentTarget;

  // Trap focus inside modal. This logic is largely copied from
  // a11y-dialog.js’s trapTabKey:
  // https://github.com/edenspiekermann/a11y-dialog/blob/a892696719969d28605b880287e802eeca507c20/a11y-dialog.js#L404-L424
  if (e.which === tabKey) {
    const interactive = modal.querySelectorAll(interactiveElements);
    const focusable = Array.prototype.filter.call(interactive, function(el) {
      // Elements that are hidden via a parent can be identified by the fact
      // that they don’t have offset width/height nor client rectangles.
      // (i.e. if any one of these values is > 0, it’s focusable)
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
    const focusedElIndex = focusable.indexOf(e.target);

    // If reverse-tabbing from the first focusable element, focus on the last.
    if (e.shiftKey && focusedElIndex === 0) {
      focusable[focusable.length - 1].focus();
      e.preventDefault();
      // If forward-tabbing from the last focusable element, focus on the first.
    } else if (!e.shiftKey && focusedElIndex === focusable.length -1) {
      focusable[0].focus();
      e.preventDefault();
    }

    // Dismiss modal when ESC is pressed.
  } else if (e.which === escKey && typeof modalCloseFunc === 'function') {
    modalCloseFunc();
  }
}

// Generic debounce function
// Taken from: https://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this, args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

(function (window, document) {
  'use strict';

  // Apply object-fit polyfill
  // Requires object-fit-cover (included in build)
  objectFitImages('img.u-object-fit-cover');

  // Fixes IOS double tap tooltip hover state and checkbox on PLP
  // http://fofwebdesign.co.uk/template/_testing/ios-sticky-hover-fix.htm
  document.addEventListener('touchend', function () {});

  // Used to trigger native events on elements like form items. Varies from
  // window.componentEvents by being called on specific items and triggering
  // native event listeners.
  window.triggerNativeEvent = function (item, type) {
    const event = document.createEvent('HTMLEvents');
    event.initEvent(type, false, true);
    item.dispatchEvent(event);
  }

  // Initialize custom swipe behavior on any elements that require it.
  const swipeElements = document.querySelectorAll('.js-swipe');
  for (let i = 0; i < swipeElements.length; i++) {
    initSwipe(swipeElements[i]);
  }

  // Custom swipe behavior (currently only handles horizontal swipes).
  // To add to an element: add a `js-swipe` class to the element, then listen
  // for and respond to swipes like so:
  //
  // ```
  // const swipeElement = parentInstance.querySelector('.js-swipe');
  //
  // if (typeof swipeElement.events !== 'undefined') {
  //   swipeElement.events.on('swipe', handleSwipe);
  // }
  // ```
  //
  // `handleSwipe()` (or whatever it is named) will be passed 2 arguments: the
  // element that was swiped and the direction that it was swiped.
  function initSwipe(element) {
    const tolerance = 20;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let diffX = 0;
    let diffY = 0;

    function swipeStart(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }

    function swipeEnd(e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    }

    function handleSwipe() {
      diffX = Math.abs(touchEndX - touchStartX);
      diffY = Math.abs(touchEndY - touchStartY);

      if (diffX > diffY && diffX > tolerance) {
        if (touchEndX > touchStartX) {
          element.events.emitEvent('swipe', [element, 'left']);
        }
        else if (touchEndX < touchStartX) {
          element.events.emitEvent('swipe', [element, 'right']);
        }
      }
      // Add an `else if` condition here to support vertical swipe events.
    }

    element.events = new EvEmitter();

    element.addEventListener('touchstart', swipeStart, false);
    element.addEventListener('touchend', swipeEnd, false);
  }
}(window, window.document));

// Create a global mjpl object with data collected via captureMetadata.
window.mjpl = window.captureMetadata('mjpl', {});
